module.exports = "html{box-sizing:border-box}*{background:transparent;border:0;font-family:inherit;font-size:inherit;list-style:none;margin:0;padding:0;text-align:inherit}*,:after,:before{box-sizing:inherit}audio,embed,iframe,img,object,video{height:auto;max-width:100%}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-init/theme/reset.global.scss
// module id = 149
// module chunks = 0 1 39